import { InterestSector } from '@interfaces/interestSector.interface';

import api from './';

export const { useGetInterestSectorsQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getInterestSectors: build.query<InterestSector[], void>({
      query: () => ({ url: 'interest-sector' }),
    }),
  }),
});
